import type { Product } from '@shopify/hydrogen/dist/esnext/storefront-api-types';
import type { PartialDeep } from 'type-fest';
import { CoverSectionScience } from './cover';
import { WhatSectionScience } from './what';
import { WhySectionScience } from './why';
import { EvolutionSectionScience } from './evolution';
import { MonitorSectionScience } from './monitor';
import { ImproveSectionScience } from './improve';
import { BuySection } from '../buy-section';
import { BlogSectionScience } from './blog';
import { ReferencesSectionScience } from './references';
import { ScienceTeam } from './scientists';
import { AdvisorsSectionScience } from './advisors';

interface SciencePageProps {
  product: PartialDeep<Product>;
}

export function SciencePage({ product }: SciencePageProps) {
  return (
    <>
      <CoverSectionScience />
      <WhatSectionScience />
      <WhySectionScience />
      <EvolutionSectionScience />
      <MonitorSectionScience />
      <ImproveSectionScience />
      <BuySection preset="pink" product={product} />
      <BlogSectionScience />
      <ScienceTeam />
      <AdvisorsSectionScience />
      <ReferencesSectionScience />
    </>
  );
}
